/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { assertIsDefined } from '@bingads-webui-campaign-react/debug-assert';
import { ColumnFormat, I18n, getFormatter } from '@bingads-webui-grid/well-known';
import { IColumn } from '@fluentui/react';
import { ListingGroupColumn, AssetGroupNameColumn, IncludeExcludeColumn } from '../../rawColumns';
import { ListingGroupGridColumnOnRender, ListingGroupGridItemData, } from '../../interface';
import { getPropertyFromItem, shouldEnableEdit, IsCurrentAccountInactive, IsReadOnlyMode } from '../utils';
import { columnKeyRawDataMap } from '../../ColumnOdataMap';
import { Model$Listing } from '../../ApiType';
import { ConditionTemplate } from './ConditionTemplate';
import { FlattenConditionTemplate } from './FlattenConditionTemplate';
import { NameTemplate } from './NameTemplate';
import { IncludeExcludeTemplate } from './IncludeExcludeTemplate';

const PATH_SPLITER = '>';

const isEverythingElse = (condition: Model$Listing) =>
  !!(!condition.Attribute && condition.Operand);

const isAllProduct = (condition: Model$Listing) =>
  !!(condition.Operand === '' && !condition.Attribute);

const getNearestParentCondition = (parentConditions: Model$Listing[]) => (parentConditions[parentConditions.length - 1]);

export const getDisplayName = (condition: Model$Listing, parentConditions:Model$Listing[], i18n: I18n): any => {
  if (isAllProduct(condition)) {
    return i18n.getString(_TL_('All Products'));
  }
  const parentCondition = getNearestParentCondition(parentConditions);
  if (isEverythingElse(condition)) {
    if (isEverythingElse(parentCondition)) {
      return i18n.getString(_TL_('Everything else'));
    }
    return i18n.getString(_TL_("Everything else in '{0}'")).replace('{0}', getDisplayName(parentCondition, parentConditions.slice(0, -1), i18n));
  }
  return condition.Attribute;
};

const getPath = (parentConditions: Model$Listing[], i18n: I18n) => {
  if (!parentConditions || parentConditions.length === 0) {
    return '';
  }
  let path = '';
  path += getDisplayName(parentConditions[0], [], i18n);
  for (let i = 1; i < parentConditions.length; i += 1) {
    path += ` ${PATH_SPLITER} ${getDisplayName(parentConditions[i], parentConditions.slice(0, i), i18n)}`;
  }
  return path;
};

const getFullPath = (conditions: Model$Listing[], i18n: I18n) => {
  const path: any[] = [];
  for (let i = 0; i < conditions.length; i += 1) {
    path.push({
      ...conditions[i],
      Attribute: getDisplayName(conditions[i], conditions.slice(0, i), i18n),
    });
  }
  return path;
};

export function getAttributeTextOfConditionTemplate(i18n: I18n, item: ListingGroupGridItemData) {
  assertIsDefined(item.treeViewInfo);
  assertIsDefined(item.Condition);
  const parentItem = item.treeViewInfo.parent;
  let attributeText: string;
  if (isAllProduct(item.Condition)) {
    attributeText = i18n.getString(_TL_('All Products'));
  } else if (isEverythingElse(item.Condition)) {
    // if item is not root, it must have parent.
    assertIsDefined(parentItem?.Condition);
    if (isEverythingElse(parentItem.Condition)) {
      // Parent node is everything else
      attributeText = i18n.getString(_TL_('Everything else'));
    } else {
      // Everything else in `parent's attribute`
      const parentAttribute = parentItem.Condition.Attribute || i18n.getString(_TL_('All Products'));

      attributeText = i18n.getString(_TL_("Everything else in '{0}'")).replace('{0}', parentAttribute);
    }
  } else {
    assertIsDefined(item.Condition.Attribute);
    attributeText = item.Condition.Attribute;
  }
  return attributeText;
}

const onListingGroupColumnRender: ListingGroupGridColumnOnRender = (itemData) => {
  const isTreeView = !!itemData?.treeViewInfo;
  if (isTreeView) {
    return onListingGroupColumnTreeViewRender(itemData);
  }
  return onListingGroupColumnListViewRender(itemData);
};

const onAssetGroupNameColumnRender: ListingGroupGridColumnOnRender = (itemData) => {
  assertIsDefined(itemData, 'item with no data');
  const { i18n, serverContext, scope } = itemData;
  const name = itemData.AssetGroupName;
  const assetGroupId = itemData.AssetGroupId;
  const currentCampaign = serverContext.CurrentCampaign;
  // In campaign level, there is no CampaignId in row value
  const cmpid = itemData.CampaignId || (currentCampaign && currentCampaign.Id);
  const ariaLabel = i18n.getString(_TL_('Click to scope to asset group {{assetGroupName}}'), { assetGroupName: name });

  return (
    <NameTemplate
      ariaLabel={ariaLabel}
      campaignId={cmpid}
      assetGroupId={assetGroupId}
      scope={scope}
      name={name ?? ''}
    />
  );
};

const onIncludeExcludeColumnRender: ListingGroupGridColumnOnRender = (itemData) => {
  assertIsDefined(itemData, 'item with no data');
  return (<IncludeExcludeTemplate itemData={itemData} />);
};

const onListingGroupColumnListViewRender: ListingGroupGridColumnOnRender = (itemData) => {
  assertIsDefined(itemData, 'item with no data');
  const { i18n, scope } = itemData;
  // if (value.$total) {
  //   return flattenConditionTemplate(value);
  // }
  const condition = { ...itemData.Condition };
  const parentConditions = itemData.ParentConditions;
  assertIsDefined(parentConditions);
  const attribute = getDisplayName(condition, parentConditions, i18n);
  const path = getPath(parentConditions, i18n);
  const conditions = itemData.ParentConditions ?
    [...itemData.ParentConditions, itemData.Condition] : [itemData.Condition];
  const partitionFullPath = getFullPath(conditions, i18n);
  return (<FlattenConditionTemplate
    Attribute={attribute}
    i18n={i18n}
    path={path}
    partitionFullPath={partitionFullPath}
    scope={scope}
    productListingGroupId={itemData.Id}
    assetGroupId={itemData.AssetGroupId}
  />);
};

const onListingGroupColumnTreeViewRender: ListingGroupGridColumnOnRender = (itemData) => {
  assertIsDefined(itemData?.treeViewInfo);
  assertIsDefined(itemData.treeViewInfo.depth);
  assertIsDefined(itemData.treeViewInfo.hasChildren);
  const {
    serverContext, i18n, total, scope, parentConditions,
    treeViewInfo: { hasChildren, depth, isExpanded },
  } = itemData;

  const showSelectorIcon = shouldEnableEdit(!IsCurrentAccountInactive(serverContext) &&
    !IsReadOnlyMode(serverContext) && (hasChildren || depth < 7), serverContext);

  function onToggleCollapse() {
    assertIsDefined(itemData?.eventHandlers.onTreeViewColumnToggleCollapse);
    itemData.eventHandlers.onTreeViewColumnToggleCollapse(itemData);
  }

  function onAddOrEditTrigger() {
    assertIsDefined(itemData?.eventHandlers.onTreeViewColumnAddOrEdit);
    itemData.eventHandlers.onTreeViewColumnAddOrEdit(itemData as any); // TODO: not use this trick
  }

  const attributeText = getAttributeTextOfConditionTemplate(i18n, itemData);

  assertIsDefined(parentConditions);
  const conditions = itemData.ParentConditions ?
    [...itemData.ParentConditions, itemData.Condition] : [itemData.Condition];
  const partitionFullPath = getFullPath(conditions, i18n);

  return (<ConditionTemplate
    onAddOrEditTrigger={() => onAddOrEditTrigger()}
    onToggleCollapse={() => onToggleCollapse()}
    attributeText={attributeText}
    depth={depth}
    hasChildren={hasChildren}
    i18n={i18n}
    isExpanded={!!isExpanded}
    showSelectorIcon={showSelectorIcon}
    total={total}
    partitionFullPath={partitionFullPath}
    scope={scope}
    productListingGroupId={itemData.Id}
    assetGroupId={itemData.AssetGroupId}
  />);
};

/**
 * key is the key of column raw data
 *
 * value is the render callback of fluentUI
 */
const columnRenderMap: Map<string, ListingGroupGridColumnOnRender> = new Map([
  [IncludeExcludeColumn.key, onIncludeExcludeColumnRender],
  [ListingGroupColumn.key, onListingGroupColumnRender],
  [AssetGroupNameColumn.key, onAssetGroupNameColumnRender],
]);

const defaultRender: ListingGroupGridColumnOnRender = getFormattedPropertyValueOfItem;

function getFormattedPropertyValueOfItem(itemData: ListingGroupGridItemData | undefined, index: number | undefined, column: IColumn | undefined): string {
  assertIsDefined(itemData);
  assertIsDefined(column);
  const value = getPropertyFromItem(itemData, index, column);
  const format = getFormatOfColumn(column);
  return tryGetFormatString(value, itemData.i18n, format);
}

function getFormatOfColumn(column: IColumn) {
  return columnKeyRawDataMap[column.key].format;
}

export function tryGetFormatString(value: string | number, i18n: I18n, format: ColumnFormat | undefined) {
  if (format) {
    const formatter = getFormatter(format, i18n);
    return formatter(value);
  }
  return value;
}

export function getColumnRenderByColumnKey(columnKey: string) {
  if (columnRenderMap.has(columnKey)) {
    return columnRenderMap.get(columnKey);
  }
  return defaultRender;
}
